var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.993 1.95A5.742 5.742 0 016 .334c1.503 0 2.944.582 4.007 1.618a5.453 5.453 0 011.66 3.905c0 1.465-.597 2.87-1.66 3.905l-3.658 3.566a.5.5 0 01-.698 0L1.993 9.76A5.515 5.515 0 01.765 7.97a5.401 5.401 0 010-4.227A5.515 5.515 0 011.993 1.95zM6 7.435c.43 0 .841-.166 1.145-.462.303-.296.474-.697.474-1.116 0-.418-.17-.82-.474-1.116A1.64 1.64 0 006 4.278c-.43 0-.841.167-1.145.462a1.558 1.558 0 00-.474 1.116c0 .419.17.82.474 1.116A1.64 1.64 0 006 7.434z",
    fill: "#818181"
  })));
}

export default SvgLocationGrey;